import { motion } from "framer-motion";

/**
 * Signature korv. matte candle vessel — cylinder with wick + subtle wax meniscus.
 */
export default function KorvCandle({
  color = "#221410",
  accent = "#c9a67a",
  label = "korv.",
  scent = "ENCENS",
  className = "",
  animate = true,
}) {
  const uid = (color + accent).replace(/[^a-z0-9]/gi, "");
  const inkText = "#EDE6D8";

  return (
    <motion.svg
      viewBox="0 0 240 380"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      initial={animate ? { y: 24, opacity: 0 } : false}
      whileInView={animate ? { y: 0, opacity: 1 } : false}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 1.4, ease: [0.2, 0.7, 0.1, 1] }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id={`cg-${uid}`} cx="50%" cy="50%" r="50%">
          <stop offset="0" stopColor="rgba(20,18,17,0.42)" />
          <stop offset="1" stopColor="rgba(20,18,17,0)" />
        </radialGradient>
        <linearGradient id={`cb-${uid}`} x1="0.05" y1="0" x2="0.98" y2="0">
          <stop offset="0"    stopColor="rgba(255,255,255,0.00)" />
          <stop offset="0.05" stopColor="rgba(255,255,255,0.16)" />
          <stop offset="0.25" stopColor="rgba(255,255,255,0.06)" />
          <stop offset="0.55" stopColor="rgba(0,0,0,0)" />
          <stop offset="0.82" stopColor="rgba(0,0,0,0.14)" />
          <stop offset="1"    stopColor="rgba(0,0,0,0.32)" />
        </linearGradient>
        <linearGradient id={`wax-${uid}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="rgba(255,240,220,0.18)" />
          <stop offset="1" stopColor="rgba(0,0,0,0)" />
        </linearGradient>
        <clipPath id={`cbc-${uid}`}>
          <rect x="42" y="60" width="156" height="290" rx="4" />
        </clipPath>
      </defs>

      {/* Ground */}
      <ellipse cx="120" cy="362" rx="80" ry="8" fill={`url(#cg-${uid})`} />

      {/* Wax meniscus / opening top */}
      <ellipse cx="120" cy="60" rx="78" ry="10" fill="#0f0b09" />
      <ellipse cx="120" cy="58" rx="72" ry="6" fill={color} />
      <ellipse cx="120" cy="58" rx="72" ry="6" fill={`url(#wax-${uid})`} />

      {/* Wick */}
      <line x1="120" y1="46" x2="120" y2="60" stroke="#141212" strokeWidth="1.6" />
      <ellipse cx="120" cy="43" rx="1.6" ry="2.4" fill="#3a2530" />

      {/* Body cylinder */}
      <rect x="42" y="60" width="156" height="290" rx="4" fill={color} />
      <g clipPath={`url(#cbc-${uid})`}>
        <rect x="0" y="60" width="240" height="290" fill={`url(#cb-${uid})`} />
      </g>
      <rect x="42" y="60" width="156" height="290" rx="4" fill="none" stroke="rgba(0,0,0,0.20)" strokeWidth="0.6" />

      {/* Base disc shadow */}
      <ellipse cx="120" cy="350" rx="78" ry="6" fill="rgba(0,0,0,0.28)" />

      {/* Wordmark */}
      <text x="120" y="200" textAnchor="middle" fill={inkText}
        fontFamily="Fraunces, serif" fontWeight="500" fontSize="30" letterSpacing="-1"
        style={{ fontVariationSettings: "'opsz' 144" }}>
        {label}
      </text>
      <text x="120" y="228" textAnchor="middle" fill={accent} fillOpacity="0.75"
        fontFamily="'Inter Tight', sans-serif" fontWeight="500" fontSize="9" letterSpacing="3">
        {scent}
      </text>
      <line x1="98" y1="240" x2="142" y2="240" stroke={accent} strokeOpacity="0.5" strokeWidth="0.6" />
      <text x="120" y="258" textAnchor="middle" fill="rgba(237,230,216,0.5)"
        fontFamily="'Inter Tight', sans-serif" fontWeight="300" fontSize="6.5" letterSpacing="2">
        HAND-POURED · 60 HR
      </text>
    </motion.svg>
  );
}
